module.exports = __webpack_public_path__ + "img/3.79d8e40f.jpeg";